import { connect } from 'react-redux';

import contractsActionCreators from '_store/_actions/contract';
import companyTransactionsActionCreators from '_store/_actions/companyTransactions';

import ContractGeneration from './ContractGeneration';

const mapStateToProps = state => ({
  activeCompany: state.company.activeCompany,
  contracts: state.contracts.contracts,
  isLoadingContracts: state.contracts.isLoading,
  allContacts: state.companyTransactions.recipients,
  user: state.auth.user,
  isLoadingRecipients: state.companyTransactions.isLoadingSimpleRecipients,
});

const mapDispatchToProps = {
  onFetchAllContracts: contractsActionCreators.fetchAllContracts,
  onFetchContact: companyTransactionsActionCreators.fetchContactById,
  onFetchContacts: companyTransactionsActionCreators.fetchAllRecipientsSimple,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContractGeneration);
